import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const AuthRoute = ({ children, ...rest }) => {
     // const { user, currentApp } = useSelector(state => state);

     const currentApp = localStorage.getItem('@kupos_admin_app')
         ? localStorage.getItem('@kupos_admin_app')
         : null;

     const user = localStorage.getItem('@kupos_admin_user')
         ? JSON.parse(localStorage.getItem('@kupos_admin_user'))
         : null;

     const isLoggedIn = user && currentApp;
     return isLoggedIn ? <Route {...rest} /> : <Redirect to="/login" />;
};

export default AuthRoute;
